module.exports = __webpack_public_path__ + "static/media/Lato-Heavy.72c6dd53.ttf";